
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1819',
  depVersions: {
  "customer-portal-app": "static-1.1819",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9536",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24896",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5453",
  "hs-test-utils": "static-1.7867",
  "hub-http": "static-1.6076",
  "hub-http-shared-msw-handlers": "static-1.9621",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17770",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11302",
  "I18n": "static-7.1590",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6329",
  "payment-link-components": "static-1.23096",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6811",
  "quartz-core": "static-1.6030",
  "react": "static-7.182",
  "react-colorpicker": "static-2.10071",
  "react-dlb": "static-1.74",
  "react-utils": "static-2.5230",
  "rich-text-lib": "static-1.19576",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17744",
  "ui-components-test-utils": "static-1.5440",
  "UIComponents": "static-3.8249",
  "foundations-assets": "static-1.4701",
  "foundations-components": "static-1.7635",
  "foundations-theming": "static-1.4270",
  "foundations-theming-specialty": "static-1.1986",
  "framer-motion": "static-1.68",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.614",
  "quartz-config": "static-1.589",
  "quartz-routing": "static-1.241",
  "quick-fetch": "static-1.3794",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16510",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8005",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.51",
  "ui-addon-draggable": "static-3.4628",
  "ui-addon-react-router-dom": "static-1.9405",
  "usage-tracker": "static-1.7194",
  "usage-tracker-anonymous": "static-1.5611",
  "usage-tracker-core": "static-1.7044",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3285",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3088",
  "quartz-webpack": "static-1.3035",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "customer-data-objects": "static-1.7512",
  "frontend-preferences-client": "static-1.7783",
  "laboratory-lib": "static-3.7019",
  "onboarding-scopes": "static-1.6323",
  "rpc-client-utils": "static-1.4502",
  "ui-addon-opt": "static-4.8243",
  "HeadJS": "static-2.725",
  "hs-test-utils-bend-plugin": "static-1.2978",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3961",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7532",
  "cssUtils": "static-1.755",
  "customer-data-ui-utilities": "static-1.9684",
  "HubStyle": "static-2.11610",
  "knowledge-content-types": "static-1.8418",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.486",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9747",
  "ui-addon-i18n": "static-1.11004",
  "ui-business-units-lib": "static-1.8892",
  "ui-shepherd-react": "static-3.10006",
  "video-components-external": "static-1.10763",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4185",
  "commerce-tours-lib": "static-1.5811",
  "customer-data-properties": "static-1.50972",
  "getting-started-shared-tasks": "static-1.18048",
  "growth-onboarding-reliability": "static-1.4946",
  "onboarding-tours": "static-1.16346",
  "reference-resolvers-lite": "static-1.7945",
  "sales-checkout-service-client": "static-1.3528",
  "ui-addon-iframeable": "static-1.8907",
  "user-context": "static-1.4960",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.810",
  "hubspotter-http": "static-1.4534",
  "icons": "static-2.631",
  "mobile-manifest-mixins": "static-1.500",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.486",
  "quartz-head": "static-1.476",
  "quartz-test": "static-1.486",
  "quartz-tracking": "static-1.190",
  "ui-fonts": "static-1.564",
  "usage-tracker-container": "static-1.7184",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9285",
  "data-token-picker": "static-1.16148",
  "FileManagerLib": "static-1.38731",
  "property-translator": "static-1.5270",
  "atom": "static-1.4930",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5571",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.180",
  "foundations-components-test-utils": "static-1.5118",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1114",
  "bend-plugin-foundations-components": "static-1.3904",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "trellis-assets": "static-1.1370",
  "bend-plugin-foundations-theming": "static-1.2753",
  "foundations-theming-base": "static-1.3255",
  "stylex": "static-1.28",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5608",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4334",
  "react-flip-move": "static-1.66",
  "bender-build-tools": "static-1.3014",
  "inbound-db-properties-service-client": "static-1.3727",
  "superstore": "static-1.4628",
  "chirp-fetch": "static-1.1743",
  "feedback-loader": "static-1.28987",
  "ai-components-ui-library": "static-1.8529",
  "ui-addon-video-player": "static-1.8556",
  "ui-coaching-tips": "static-1.28102",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4480",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2351",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8023",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4511",
  "content-media-composition-data-lib": "static-1.11691",
  "content-media-compositions": "static-2.15698",
  "idb-keyval": "static-1.40",
  "immer": "static-1.33",
  "immerable": "static-1.4014",
  "magpie-lib": "static-1.5453",
  "magpie-types": "static-1.4913",
  "media-bridge-lib": "static-1.18670",
  "video-data-lib": "static-1.34421",
  "commerce-products-lib": "static-1.9015",
  "crm-message-bus": "static-1.42546",
  "growth-data-modal": "static-1.5219",
  "hubspot-apollo-client": "static-1.4739",
  "onboarding-tours-client": "static-1.4560",
  "calling-global-api": "static-1.63912",
  "calling-internal-common": "static-1.31159",
  "calling-lifecycle-internal": "static-1.65294",
  "calling-lifecycle-messages": "static-1.57588",
  "conditional-properties-service-client": "static-1.3679",
  "crm-links": "static-1.6128",
  "customer-data-objects-ui-components": "static-1.12872",
  "customer-data-property-utils": "static-1.7940",
  "external-options-client-types": "static-1.4040",
  "file-manager-components": "static-1.23091",
  "framework-data-schema-resolvers": "static-1.6733",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.546",
  "inbound-db-meta-service-client": "static-1.3476",
  "inbounddb-objects-service-types": "static-1.4104",
  "meetings-icalendar-utils-lib": "static-1.492",
  "multi-currency-client-types": "static-1.3571",
  "object-builder-ui-client": "static-1.48192",
  "pipeline-validation-client-types": "static-1.3845",
  "property-value-citations": "static-1.1586",
  "pulse": "static-1.383",
  "smart-property-lib": "static-1.6166",
  "tiered-pricing": "static-1.922",
  "ui-addon-form-validation": "static-1.10853",
  "growth-onboarding-confetti": "static-1.2932",
  "growth-onboarding-next-action-utils": "static-1.1454",
  "navigation-components": "static-1.17461",
  "onboarding-tours-utils": "static-1.412",
  "ui-shepherd-tracker": "static-1.7387",
  "ui-universal-auth": "static-1.8782",
  "batch-promise": "static-1.1411",
  "navigation-messaging": "static-1.6788",
  "getting-started-shared-tasks-store": "static-1.17166",
  "hubspotter-http-shared-msw-handlers": "static-1.9619",
  "usage-tracker-session-replay": "static-1.4880",
  "audio-components": "static-1.5696",
  "FileManagerCore": "static-1.38590",
  "FileManagerImages": "static-1.36242",
  "video-components": "static-1.12766",
  "foundations-components-legacy": "static-1.660",
  "growth-monetization-service-types": "static-1.4359",
  "nav-client-types": "static-1.2217",
  "purchase-motions-api": "static-1.5574",
  "self-service-api": "static-1.10102",
  "signup-constants": "static-1.18518",
  "signup-ui-url-generator": "static-2.7894",
  "trials-service-types": "static-1.3760",
  "usage-tracker-public": "static-1.7005",
  "chatspot-core": "static-1.20577",
  "ContentUtils": "static-1.67806",
  "copilot-toolkit": "static-1.10689",
  "growth-onboarding-feedback-components": "static-1.6441",
  "hls.js": "static-1.35",
  "reactive-lib": "static-1.585",
  "simple-logging-lib": "static-1.2910",
  "commerce-permissions": "static-1.623",
  "customer-data-tracking": "static-1.6742",
  "products-iframe-lib": "static-1.7494",
  "products-ui-components-shared-msw-handlers": "static-1.10003",
  "hubspot-apollo-cache": "static-1.198",
  "calling-error-reporting": "static-1.31165",
  "shared-worker-versioning": "static-1.10899",
  "calling-usage-tracker": "static-1.6401",
  "voice-sms-access-library": "static-1.421",
  "conversations-skeleton-state": "static-1.7108",
  "location-customization-utils-lib": "static-1.8753",
  "crm-pipelines-api-client-types": "static-1.4021",
  "framework-builder-read-service-client": "static-1.3889",
  "framework-data-schema-quick-fetch": "static-1.6638",
  "persist-promise": "static-1.3568",
  "directed-graph": "static-1.799",
  "event-emitter": "static-1.807",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5406",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9704",
  "fsm": "static-1.3590",
  "policy-lib": "static-1.6638",
  "react-tinymce": "static-1.54791",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9767",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53917",
  "tinymce-plugins": "static-1.57031",
  "tinymce-themes": "static-1.55887",
  "growth-onboarding-next-action-components": "static-1.1482",
  "user-context-client": "static-1.4477",
  "unified-auth-core-lib": "static-1.577",
  "amplitude-session-replay-browser": "static-1.56",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4391",
  "video-embed": "static-1.35255",
  "content-icons-ui": "static-1.2179",
  "social-insights-client-types": "static-1.21553",
  "eligibility-engine-service-types": "static-1.3041",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4669",
  "integrations-lib": "static-1.15614",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4135",
  "calling-orchestration-schema": "static-1.35198",
  "crm-record-cards-service-types": "static-1.3498",
  "highcharts": "static-8.100",
  "trellis-story-utils": "static-1.4379",
  "storybook-react": "static-1.29",
  "hub-http-contrib": "static-1.2903",
  "interframe": "static-3.4622",
  "tinymce-data": "static-1.40002",
  "ui-addon-sales-email": "static-1.5073",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12157",
  "layout-dnd-utils": "static-1.11132",
  "react-codemirror": "static-1.10486",
  "ui-brand-identity-lib": "static-1.14306",
  "NamespacedHubStyle": "static-2.8951",
  "outpost": "static-1.4060",
  "flux-actions": "static-1.318",
  "integrations-error-boundary-lib": "static-1.13029",
  "integrations-tracking-lib": "static-1.5450",
  "native-integrations-shared-strings": "static-1.7647",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10234",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67881",
  "layout-data-lib": "static-1.9457",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2860",
  "advanced-menus-core": "static-1.14902",
  "advanced-menus-lib": "static-1.11870",
  "ExportDialog": "static-6.10247",
  "ui-memberships-settings-lib": "static-1.33609",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14901",
  "simple-menus-lib": "static-1.16418"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1819",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9536",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24896",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5453",
  "hs-test-utils": "/hs-test-utils/static-1.7867",
  "hub-http": "/hub-http/static-1.6076",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9621",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17770",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11302",
  "I18n": "/I18n/static-7.1590",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6329",
  "payment-link-components": "/payment-link-components/static-1.23096",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6811",
  "quartz-core": "/quartz-core/static-1.6030",
  "react": "/react/static-7.182",
  "react-colorpicker": "/react-colorpicker/static-2.10071",
  "react-dlb": "/react-dlb/static-1.74",
  "react-utils": "/react-utils/static-2.5230",
  "rich-text-lib": "/rich-text-lib/static-1.19576",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17744",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5440",
  "UIComponents": "/UIComponents/static-3.8249",
  "foundations-assets": "/foundations-assets/static-1.4701",
  "foundations-components": "/foundations-components/static-1.7635",
  "foundations-theming": "/foundations-theming/static-1.4270",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1986",
  "framer-motion": "/framer-motion/static-1.68",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.614",
  "quartz-config": "/quartz-config/static-1.589",
  "quartz-routing": "/quartz-routing/static-1.241",
  "quick-fetch": "/quick-fetch/static-1.3794",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16510",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8005",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.51",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4628",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9405",
  "usage-tracker": "/usage-tracker/static-1.7194",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5611",
  "usage-tracker-core": "/usage-tracker-core/static-1.7044",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3285",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3088",
  "quartz-webpack": "/quartz-webpack/static-1.3035",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "customer-data-objects": "/customer-data-objects/static-1.7512",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7783",
  "laboratory-lib": "/laboratory-lib/static-3.7019",
  "onboarding-scopes": "/onboarding-scopes/static-1.6323",
  "rpc-client-utils": "/rpc-client-utils/static-1.4502",
  "ui-addon-opt": "/ui-addon-opt/static-4.8243",
  "HeadJS": "/HeadJS/static-2.725",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2978",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3961",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7532",
  "cssUtils": "/cssUtils/static-1.755",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9684",
  "HubStyle": "/HubStyle/static-2.11610",
  "knowledge-content-types": "/knowledge-content-types/static-1.8418",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.486",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9747",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11004",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8892",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10006",
  "video-components-external": "/video-components-external/static-1.10763",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4185",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5811",
  "customer-data-properties": "/customer-data-properties/static-1.50972",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18048",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4946",
  "onboarding-tours": "/onboarding-tours/static-1.16346",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7945",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3528",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8907",
  "user-context": "/user-context/static-1.4960",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.810",
  "hubspotter-http": "/hubspotter-http/static-1.4534",
  "icons": "/icons/static-2.631",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.500",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.486",
  "quartz-head": "/quartz-head/static-1.476",
  "quartz-test": "/quartz-test/static-1.486",
  "quartz-tracking": "/quartz-tracking/static-1.190",
  "ui-fonts": "/ui-fonts/static-1.564",
  "usage-tracker-container": "/usage-tracker-container/static-1.7184",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9285",
  "data-token-picker": "/data-token-picker/static-1.16148",
  "FileManagerLib": "/FileManagerLib/static-1.38731",
  "property-translator": "/property-translator/static-1.5270",
  "atom": "/atom/static-1.4930",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5571",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5118",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1114",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3904",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.1370",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2753",
  "foundations-theming-base": "/foundations-theming-base/static-1.3255",
  "stylex": "/stylex/static-1.28",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5608",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4334",
  "react-flip-move": "/react-flip-move/static-1.66",
  "bender-build-tools": "/bender-build-tools/static-1.3014",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3727",
  "superstore": "/superstore/static-1.4628",
  "chirp-fetch": "/chirp-fetch/static-1.1743",
  "feedback-loader": "/feedback-loader/static-1.28987",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8529",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8556",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28102",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4480",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2351",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8023",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4511",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11691",
  "content-media-compositions": "/content-media-compositions/static-2.15698",
  "idb-keyval": "/idb-keyval/static-1.40",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4014",
  "magpie-lib": "/magpie-lib/static-1.5453",
  "magpie-types": "/magpie-types/static-1.4913",
  "media-bridge-lib": "/media-bridge-lib/static-1.18670",
  "video-data-lib": "/video-data-lib/static-1.34421",
  "commerce-products-lib": "/commerce-products-lib/static-1.9015",
  "crm-message-bus": "/crm-message-bus/static-1.42546",
  "growth-data-modal": "/growth-data-modal/static-1.5219",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4739",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4560",
  "calling-global-api": "/calling-global-api/static-1.63912",
  "calling-internal-common": "/calling-internal-common/static-1.31159",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65294",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57588",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3679",
  "crm-links": "/crm-links/static-1.6128",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12872",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7940",
  "external-options-client-types": "/external-options-client-types/static-1.4040",
  "file-manager-components": "/file-manager-components/static-1.23091",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6733",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.546",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3476",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4104",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.492",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3571",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48192",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3845",
  "property-value-citations": "/property-value-citations/static-1.1586",
  "pulse": "/pulse/static-1.383",
  "smart-property-lib": "/smart-property-lib/static-1.6166",
  "tiered-pricing": "/tiered-pricing/static-1.922",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10853",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2932",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1454",
  "navigation-components": "/navigation-components/static-1.17461",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.412",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7387",
  "ui-universal-auth": "/ui-universal-auth/static-1.8782",
  "batch-promise": "/batch-promise/static-1.1411",
  "navigation-messaging": "/navigation-messaging/static-1.6788",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17166",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9619",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4880",
  "audio-components": "/audio-components/static-1.5696",
  "FileManagerCore": "/FileManagerCore/static-1.38590",
  "FileManagerImages": "/FileManagerImages/static-1.36242",
  "video-components": "/video-components/static-1.12766",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.660",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4359",
  "nav-client-types": "/nav-client-types/static-1.2217",
  "purchase-motions-api": "/purchase-motions-api/static-1.5574",
  "self-service-api": "/self-service-api/static-1.10102",
  "signup-constants": "/signup-constants/static-1.18518",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7894",
  "trials-service-types": "/trials-service-types/static-1.3760",
  "usage-tracker-public": "/usage-tracker-public/static-1.7005",
  "chatspot-core": "/chatspot-core/static-1.20577",
  "ContentUtils": "/ContentUtils/static-1.67806",
  "copilot-toolkit": "/copilot-toolkit/static-1.10689",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6441",
  "hls.js": "/hls.js/static-1.35",
  "reactive-lib": "/reactive-lib/static-1.585",
  "simple-logging-lib": "/simple-logging-lib/static-1.2910",
  "commerce-permissions": "/commerce-permissions/static-1.623",
  "customer-data-tracking": "/customer-data-tracking/static-1.6742",
  "products-iframe-lib": "/products-iframe-lib/static-1.7494",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10003",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.198",
  "calling-error-reporting": "/calling-error-reporting/static-1.31165",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10899",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6401",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.421",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7108",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8753",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4021",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3889",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6638",
  "persist-promise": "/persist-promise/static-1.3568",
  "directed-graph": "/directed-graph/static-1.799",
  "event-emitter": "/event-emitter/static-1.807",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5406",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9704",
  "fsm": "/fsm/static-1.3590",
  "policy-lib": "/policy-lib/static-1.6638",
  "react-tinymce": "/react-tinymce/static-1.54791",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9767",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53917",
  "tinymce-plugins": "/tinymce-plugins/static-1.57031",
  "tinymce-themes": "/tinymce-themes/static-1.55887",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1482",
  "user-context-client": "/user-context-client/static-1.4477",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.577",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4391",
  "video-embed": "/video-embed/static-1.35255",
  "content-icons-ui": "/content-icons-ui/static-1.2179",
  "social-insights-client-types": "/social-insights-client-types/static-1.21553",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3041",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4669",
  "integrations-lib": "/integrations-lib/static-1.15614",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35198",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3498",
  "highcharts": "/highcharts/static-8.100",
  "trellis-story-utils": "/trellis-story-utils/static-1.4379",
  "storybook-react": "/storybook-react/static-1.29",
  "hub-http-contrib": "/hub-http-contrib/static-1.2903",
  "interframe": "/interframe/static-3.4622",
  "tinymce-data": "/tinymce-data/static-1.40002",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5073",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12157",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11132",
  "react-codemirror": "/react-codemirror/static-1.10486",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14306",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8951",
  "outpost": "/outpost/static-1.4060",
  "flux-actions": "/flux-actions/static-1.318",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13029",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5450",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7647",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10234",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67881",
  "layout-data-lib": "/layout-data-lib/static-1.9457",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2860",
  "advanced-menus-core": "/advanced-menus-core/static-1.14902",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11870",
  "ExportDialog": "/ExportDialog/static-6.10247",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33609",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14901",
  "simple-menus-lib": "/simple-menus-lib/static-1.16418"
}
};
